import { render } from "./customer.vue?vue&type=template&id=1791d81c&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=1791d81c&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1791d81c"]])

export default __exports__